import i18n from 'i18next';

import { HoverCardConfig } from '@/lib/resource-config';

export const employeeHoverCardFields: HoverCardConfig = {
  type: 'employees',
  fields: [
    {
      field: 'Name',
      get label() {
        return i18n.t('general.Name', { ns: 'ui' });
      },
      type: 'text',
      hideIfEmpty: true,
    },
    {
      field: 'Initials',
      get label() {
        return i18n.t('hoverCard.Initials', { ns: 'portfolio' });
      },
      type: 'text',
      hideIfEmpty: true,
    },
    {
      type: 'row',
      fields: [
        {
          field: 'Email',
          get label() {
            return i18n.t('general.Email', { ns: 'ui' });
          },
          type: 'email',
          hideIfEmpty: true,
        },
        {
          field: 'Phone',
          get label() {
            return i18n.t('general.Phone', { ns: 'ui' });
          },
          type: 'phone',
          hideIfEmpty: true,
        },
      ],
    },

    {
      type: 'row',
      fields: [
        {
          field: 'DepartmentName',
          get label() {
            return i18n.t('facets.Department', { ns: 'portfolio' });
          },
          type: 'department',
          hideIfEmpty: true,
        },
        {
          field: 'LegalEntityName',
          get label() {
            return i18n.t('facets.LegalEntity', { ns: 'portfolio' });
          },
          type: 'legalEntity',
          hideIfEmpty: true,
        },
      ],
    },

    {
      field: 'Competencies',
      get label() {
        return i18n.t('facets.Competencies', { ns: 'portfolio' });
      },
      type: 'competencies',
      hideIfEmpty: true,
    },
  ],
};

export const customerHoverCardFields: HoverCardConfig = {
  type: 'customers',
  fields: [
    {
      field: 'Name',
      get label() {
        return i18n.t('general.Name', { ns: 'ui' });
      },
      type: 'text',
      hideIfEmpty: true,
    },
    {
      type: 'row',
      fields: [
        {
          field: 'Email',
          get label() {
            return i18n.t('general.Email', { ns: 'ui' });
          },
          type: 'email',
          hideIfEmpty: true,
        },
        {
          field: 'Phone',
          get label() {
            return i18n.t('general.Phone', { ns: 'ui' });
          },
          type: 'phone',
          hideIfEmpty: true,
        },
      ],
    },
    {
      field: 'Number',
      get label() {
        return i18n.t('columns.CustomerNumberLong', { ns: 'portfolio' });
      },
      type: 'text',
      hideIfEmpty: true,
    },
    {
      field: 'AccountManagerName',
      entityIdField: 'AccountManagerId',
      get label() {
        return i18n.t('facets.AccountManager', { ns: 'portfolio' });
      },
      type: 'employee',
      hideIfEmpty: true,
    },
    {
      field: 'SecondaryAccountManagerName',
      entityIdField: 'SecondaryAccountManagerId',
      get label() {
        return i18n.t('facets.SecondaryAccountManager', {
          ns: 'portfolio',
        });
      },
      type: 'employee',
      hideIfEmpty: true,
    },
    {
      field: 'Active',
      get label() {
        return i18n.t('facets.Active', { ns: 'portfolio' });
      },
      type: 'boolean',
    },
  ],
};

export const projectFields: HoverCardConfig = {
  type: 'projects',
  fields: [
    {
      field: 'Name',
      get label() {
        return i18n.t('columns.ProjectName', { ns: 'portfolio' });
      },
      type: 'text' as const,
    },
    {
      field: 'Number',
      get label() {
        return i18n.t('columns.ProjectNumberLong', { ns: 'portfolio' });
      },
      type: 'text' as const,
    },
    {
      field: 'CustomerName',
      get label() {
        return i18n.t('columns.CustomerName', { ns: 'portfolio' });
      },
      type: 'customer',
    },
    {
      field: 'ProjectManagerName',
      entityIdField: 'ProjectManagerId',
      get label() {
        return i18n.t('facets.ProjectManager', { ns: 'portfolio' });
      },
      type: 'employee',
      hideIfEmpty: true,
    },
    {
      field: 'LegalEntityName',
      get label() {
        return i18n.t('facets.LegalEntity', { ns: 'portfolio' });
      },
      type: 'legalEntity',
    },
    {
      field: 'DepartmentName',
      get label() {
        return i18n.t('facets.Department', { ns: 'portfolio' });
      },
      type: 'department',
    },
    {
      type: 'row' as const,
      fields: [
        {
          field: 'HealthStatusName',
          get label() {
            return i18n.t('facets.Health', { ns: 'portfolio' });
          },
          type: 'health' as const,
        },
        {
          field: 'IsActive',
          get label() {
            return i18n.t('facets.Active', { ns: 'portfolio' });
          },
          type: 'boolean' as const,
        },
      ],
    },
  ],
};
